import React, { useState, useEffect } from "react";
import {
  DayPickerRangeController,
  DayPickerSingleDateController,
} from "react-dates";
import { OkCancelRow } from "./Buttons";
import moment from "moment";
import "moment/locale/pt";

const CustomDateRangePicker = ({
  from,
  to,
  minDate,
  maxDate,
  onChange,
  onClose,
  monthsToShow = 2,
  singleDateMode = false,
}) => {
  moment.locale("pt");
  if (!moment.locales().includes("pt-custom")) {
    moment.updateLocale("pt", {
      weekdaysMin: ["Do", "2ª", "3ª", "4ª", "5ª", "6ª", "Sá"],
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    });
  }

  const [renderKey, setRenderKey] = useState(0);

  const [tempState, setTempState] = useState({
    startDate: from ? moment(from) : null,
    endDate: to ? moment(to) : null,
    focusedInput: "startDate",
    singleDate: from ? moment(from) : null,
  });

  useEffect(() => {
    const startDate = from ? moment(from) : null;
    const endDate = to ? moment(to) : null;

    setTempState({
      startDate,
      endDate,

      focusedInput: from && to ? "startDate" : from ? "endDate" : "startDate",
      singleDate: from ? moment(from) : null,
    });

    setRenderKey((prev) => prev + 1);
  }, [from, to, singleDateMode]);

  const handleDatesChange = ({ startDate, endDate }) => {
    setTempState((prev) => ({ ...prev, startDate, endDate }));
  };

  const handleSingleDateChange = (date) => {
    setTempState((prev) => ({ ...prev, singleDate: date }));
  };

  const onOk = () => {
    if (singleDateMode) {
      if (tempState.singleDate) {
        onChange({
          from: tempState.singleDate.startOf("day").toISOString(),
          to: tempState.singleDate.endOf("day").toISOString(),
        });
      }
    } else {
      if (tempState.startDate) {
        onChange({
          from: tempState.startDate.startOf("day").toISOString(),
          to: (tempState.endDate || tempState.startDate)
            .endOf("day")
            .toISOString(),
        });
      } else {
        onChange({ from: null, to: null });
      }
    }
  };

  const onCancel = () => {
    if (onClose) onClose();
  };

  const isOutsideRange = (day) => {
    const isBeforeFirst = minDate
      ? day.isBefore(moment(minDate), "day")
      : false;
    const isAfterLast = maxDate ? day.isAfter(moment(maxDate), "day") : false;

    return isBeforeFirst || isAfterLast;
  };

  return (
    <div className="flex flex-col items-center w-max p-2">
      <p className="text-sm text-gray-400 mb-2 text-center whitespace-pre-line">
        {singleDateMode
          ? "Escolha um único dia e clique em 'Aceitar'."
          : "Analise um período de dias ao escolher o primeiro e último dia.\nAnalise apenas um dia ao escolher o dia e clicar em 'Aceitar'."}
      </p>

      {singleDateMode ? (
        <DayPickerSingleDateController
          date={tempState.singleDate}
          onDateChange={handleSingleDateChange}
          isOutsideRange={isOutsideRange}
          numberOfMonths={1}
          daySize={28}
          noBorder
          hideKeyboardShortcutsPanel
          renderMonthElement={({ month }) => (
            <div className="flex justify-center mb-2">
              <span className="bg-btn-primary text-white rounded-full px-4 py-1 text-sm font-medium">
                {month.format("MMMM")}
              </span>
            </div>
          )}
          renderCalendarInfo={() => (
            <OkCancelRow
              className="pr-4 pb-4 justify-center"
              onOk={onOk}
              onCancel={onCancel}
            />
          )}
        />
      ) : (
        <DayPickerRangeController
          key={`range-${renderKey}`}
          initialVisibleMonth={() => (from ? moment(from) : moment())}
          minimumNights={0}
          numberOfMonths={monthsToShow}
          transitionDuration={0}
          daySize={28}
          startDate={tempState.startDate}
          endDate={tempState.endDate}
          onDatesChange={handleDatesChange}
          isOutsideRange={isOutsideRange}
          focusedInput={tempState.focusedInput}
          onFocusChange={(focusedInput) => {
            setTempState((prev) => ({
              ...prev,
              focusedInput: focusedInput || "startDate",
            }));
          }}
          noBorder
          hideKeyboardShortcutsPanel
          renderMonthElement={({ month }) => (
            <div className="flex justify-center mb-2">
              <span className="bg-btn-primary text-white rounded-full px-4 py-1 text-sm font-medium">
                {month.format("MMMM")}
              </span>
            </div>
          )}
          renderCalendarInfo={() => (
            <OkCancelRow
              className="pr-4 pb-4 justify-center"
              onOk={onOk}
              onCancel={onCancel}
            />
          )}
        />
      )}
    </div>
  );
};

export default CustomDateRangePicker;
